import { render, staticRenderFns } from "./ShareNavigationItem.vue?vue&type=template&id=20eddbd8&scoped=true&"
import script from "./ShareNavigationItem.vue?vue&type=script&lang=js&"
export * from "./ShareNavigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eddbd8",
  null
  
)

export default component.exports